module.exports = __webpack_public_path__ + "static/img/logocontest.f6c54a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/themes/dragon/img/logocontest.png
// module id = SiV9
// module chunks = 1